/**
 * @generated SignedSource<<dec9b99cd5ad7a0e25b133f03affd02f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalListItemDescription_signal$data = {
  readonly body: string | null;
  readonly descriptionFiles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContentFiles_files">;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContent_images">;
  }>;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "WorkspaceSignalListItemDescription_signal";
};
export type WorkspaceSignalListItemDescription_signal$key = {
  readonly " $data"?: WorkspaceSignalListItemDescription_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalListItemDescription_signal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalListItemDescription_signal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemDescriptionContent_images"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemDescriptionContentFiles_files"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SignalWorkspace",
  "abstractKey": null
};

(node as any).hash = "5604469f731981eaf621ea7661b5b07e";

export default node;
